import { Client } from "@/shared/model/client.model";
import { Module } from "vuex";

export const accountStore: Module<any, any> = {
  state: {
    logon: false,
    userIdentity: null,
    authenticated: false,
    ribbonOnProfiles: "",
    activeProfiles: "",
    testMode: false,
    selectClientFromSearch: "",
    listParametersActivated: [],
  },
  getters: {
    logon: (state) => state.logon,
    account: (state) => state.userIdentity,
    authenticated: (state) => state.authenticated,
    activeProfiles: (state) => state.activeProfiles,
    ribbonOnProfiles: (state) => state.ribbonOnProfiles,
    testMode: (state) => state.testMode,
    env: (state) => {
      if (state.activeProfiles.indexOf("dev") > -1 || state.activeProfiles.indexOf("test") > -1) {
        console.log("[ONLY IN DEV / TEST ENV / ADMIN]");
        return true;
      } else if (state.userIdentity !== null) {
        if (state.userIdentity.login == "admin") return true;
      }
    },
    prod: (state) => state.activeProfiles.indexOf("prod") > -1,
    selectClientFromSearch: (state) => state.selectClientFromSearch,
    authorities: (state) => state.userIdentity.authorities,
    listParametersActivated: (state) => state.listParametersActivated,
  },
  mutations: {
    authenticate(state) {
      state.logon = true;
    },
    authenticated(state, identity) {
      state.userIdentity = identity;
      state.authenticated = true;
      state.logon = false;
    },
    logout(state) {
      state.userIdentity = null;
      state.authenticated = false;
      state.logon = false;
    },
    setActiveProfiles(state, profile) {
      state.activeProfiles = profile;
    },
    setRibbonOnProfiles(state, ribbon) {
      state.ribbonOnProfiles = ribbon;
    },
    switchTestMode(state, value) {
      console.log("TEST MODE:", value);
      state.testMode = value;
    },
    selectClientFromSearch(state, value) {
      state.selectClientFromSearch = value;
    },
    listParametersActivated(state, values) {
      state.listParametersActivated = values;
    },
  },
};
